import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Switch } from "antd";

import QuestionField from "./question-field";
import AnswerFields from "../answer/answer-fields";
import QuestionTypeDropdown from "./question-type-dropdown";
import { DeleteTrashIcon } from "../../../../../resource/icons";

const Question = (props) => {
	const {
		form: { getFieldDecorator, setFieldsValue, getFieldValue },
		questionId,
		deleteQuestion,
	} = props;
	const onDelete = () => deleteQuestion(questionId);
	const [showConfirm, setShowConfirm] = useState();
	useEffect(() => {
		const listener = () => {
			setShowConfirm(false);
		};
		document
			.getElementsByClassName("NewVoting")[0]
			.addEventListener("scroll", listener);
		document.body.addEventListener("click", listener);
		return () => {
			document
				.getElementsByClassName("NewVoting")[0]
				.removeEventListener("scroll", listener);
			document.body.removeEventListener("click", listener);
		};
	});
	return (
		<div className="NewVoting__item-block">
			<div className="question_block">
				<div className="header">
					<QuestionTypeDropdown
						{...props}
						getFieldDecorator={getFieldDecorator}
					/>
				</div>
				<QuestionField {...props} />
				<AnswerFields {...props} />
				<div className="footer">
					{getFieldDecorator(`questions[${questionId}].obligatory`, {
						initialValue: false,
						valuePropName: "checked",
					})(<Switch />)}
					<span
						className="switch-label"
						onClick={() =>
							setFieldsValue({
								[`questions[${questionId}].obligatory`]: !getFieldValue(
									`questions[${questionId}].obligatory`
								),
							})
						}
					>
						Обязательный вопрос
					</span>
					<div className="spacer" />

					<Popconfirm
						visible={showConfirm}
						placement="top"
						title={"Удалить вопрос?"}
						onConfirm={() => {
							onDelete();
							setShowConfirm(false);
						}}
						onCancel={() => {
							setShowConfirm(false);
						}}
						okText="Да"
						cancelText="Нет"
					>
						<Button
							type="link"
							className="delete-button"
							onClick={() => setShowConfirm(true)}
						>
							<span>Удалить</span>
							<DeleteTrashIcon />
						</Button>
					</Popconfirm>
				</div>
			</div>
		</div>
	);
};

export default Question;
